import { replaceUrlParam, formatterDateHandle, getSwData, parseQueryString, getQueryParam } from "utils/index"
import { fixComponent, isImage } from "@/utils/analysisTypeId.js"

export class UpdateData {
  constructor(vue) {
    this.context = vue
    this.rectAttr = null
    this.cacheDataTypes = null
    this.restDataUrl = null
    this.ids = null
    this.createCb = null
    this.updateCb = null
    this.delSlideCb = null
    this.state = vue.$store.state[vue.request_prefix]
  }
  async upDateRect(rectAttr, cacheDataTypes, restDataUrl, ids, updateCb, dataCenterContent) {
    this.rectAttr = rectAttr
    this.cacheDataTypes = cacheDataTypes
    this.restDataUrl = restDataUrl
    this.ids = ids
    this.updateCb = updateCb
    this.dataCenterContent = dataCenterContent
    const getDetailData = this.rectAttr.pluginName?.includes("getDetailDataPlugin")
    let backData = !getDetailData && await this.getAppointData() || []
    if (!getDetailData && backData.data.status !== 200) {
      this.updateCb(true, "emptyData", false, null, this.ids)
      throw new Error("后台数据为空")
    }
    const pageType = this.state.type
    // 获取详情页数据的轮播需要单独处理数据
    if (getDetailData && pageType === "detailPage") {
      const detailData = window.localStorage.getItem("detailData")
      if (detailData) {
        backData = this.getSubsData(JSON.parse(detailData))
      }
    } else {
      backData = backData?.data?.data?.datas?.datas
    }
    if (backData.length) {
      this.updateCb(false, "emptyData", false, null, this.ids)
      const completeData = this.getDataInfo(backData)
      let drawLayoutAlready = this.getSwiperContentStatus(completeData[0]) //判断轮播组件内部有没有内容
      return [drawLayoutAlready, completeData]
    } else {
      this.updateCb(true, "emptyData", false, null, this.ids)
      throw new Error("后台数据为空")
    }
  }
  getSubsData(completeData) {
    let _result = []
    Object.keys(completeData).forEach(key => {
      Object.keys(completeData[key]).forEach(dataItemKey => {
        const itemData = completeData[key][dataItemKey]
        if (itemData?.key === "多图轮播") {
          _result = itemData.subs
          return
        }
      })
    })
    return _result
  }
  //校验轮播组件中的页是否和后台数据格式一致
  getSwiperContentStatus(completeData, content, strong) {
    let result = null,
      maxSizeIndArr = null
    const swiperContent = content || this.rectAttr.content
    //每一页都没有组件的情况 直接return
    if (swiperContent.every(i => i.elementOptions.length === 0)) return result
    // 找到组件数量不为空的页返回
    let idArr = []

    if (strong === true) {
      // 外部指定强检测的情况
      ;[result, maxSizeIndArr] = [...this.getUnityContent(swiperContent, completeData, idArr, true)]
    } else if (strong === false) {
      // 外部指定弱检测的情况
      ;[result, maxSizeIndArr] = [...this.getUnityContent(swiperContent, completeData, idArr, false)]
    } else {
      // 外部未指定，就进行先找强检测→找不到?进行若检测的操作
      // 首先进行强检测，即轮播组件内单页的组件的数量和类型必须与数据一致
      ;[result, maxSizeIndArr] = [...this.getUnityContent(swiperContent, completeData, idArr, true)]
      if (result === null && maxSizeIndArr.length === 0) {
        //如果强检测返回空，说明没有一一致的，则进行若检测，检测相似度最高的
        ;[result, maxSizeIndArr] = [...this.getUnityContent(swiperContent, completeData, idArr, false)]
      }
    }
    return result ? result : maxSizeIndArr
  }
  //检测轮播中数据长度和类型是否一致的方法
  getUnityContent(swiperContent, completeData, idArr, strong) {
    let result = null,
      maxSizeIndArr = []
    for (let i = 0; i < swiperContent.length; i++) {
      idArr = []
      let exec = strong
        ? swiperContent[i].elementOptions.length === Object.keys(completeData).length
        : swiperContent[i].elementOptions.length >= 1
      if (exec) {
        const tempOptions = swiperContent[i].elementOptions
        // if (swiperContent[i].elementOptions.length >= Object.keys(completeData).length) {
        //判断在轮播单页的所有组件中数量和后台数据一致的情况下，组件类型是否一致
        swiperContent[i].elementOptions.forEach(item => {
          //找到后台数据中组件类型一致的数据下标
          let sameEleIndex = Object.keys(completeData).findIndex((k, i) => {
            return (
              (!isNaN(k) || this.rectAttr.multiImageDetail) &&
              completeData[k].component_shape.find(it => it === item.innerElement) &&
              idArr.every(it => it !== i)
            )
          })
          if (sameEleIndex !== -1 && idArr.every(i => i !== sameEleIndex)) {
            idArr.push(sameEleIndex)
          }
        })
        //用于存储所有轮播页中单页内一致组件数量与后台数据匹配度最高的页数据
        maxSizeIndArr = maxSizeIndArr.length < tempOptions.length ? swiperContent[i] : maxSizeIndArr
        if (idArr.length === swiperContent[i].elementOptions.length) {
          result = swiperContent[i]
          break
        }
      }
    }
    return [result, maxSizeIndArr]
  }
  getDataInfo(result) {
    const _result = JSON.parse(JSON.stringify(result))
    _result.forEach(item => {
      Object.keys(item).forEach(dataItemKey => {
        if (!!Number(dataItemKey) !== true && Number(dataItemKey) !== 0 && !this.rectAttr.multiImageDetail) {
          // 保留url和publicId
          if (dataItemKey === "url") return
          if (dataItemKey === "publicId") return
          if (dataItemKey === "id") return
        } else {
          if (item[dataItemKey].value === "" && !this.rectAttr.multiImageDetail) {
            delete item[dataItemKey]
          } else {
            const componentShape = fixComponent(dataItemKey, item[dataItemKey].value)
            item[dataItemKey].component_shape = componentShape
          }
        }
      })
    })
    return _result
  }
  async getAppointData() {
    if(this.rectAttr.multiImageDetail) {
      const detailData = JSON.parse(window.localStorage.getItem("detailData"))[0]
      const result = {
        data: {
          data: {
            datas: {
              datas: [],
              totalRecords: 0
            }
          },
          status: 200,
          code: 0,
          message: null
        }
      }
      detailData.graphicImgUrls.forEach(item => {
        item.imgUrl = detailData.imgUrl
        const data = {
          src: {
            key: "封面",
            value: item.src
          },
          desc: {
            key: "简介",
            value: item.desc
          }
        }
        result.data.data.datas.datas.push(data)
      })
      result.data.data.datas.totalRecords = detailData.graphicImgUrls.length
      return result
    }
    const pageSize = this.rectAttr.hasOwnProperty("swiperContent") ? this.rectAttr.swiperContent : this.rectAttr.content.length
    let typeId = undefined
    if (this.cacheDataTypes.length) {
      // 轮播没有分类 有多个分类时获取第一个
      typeId = this.cacheDataTypes[0]
    }
    let url = replaceUrlParam(this.restDataUrl, "t", typeId ? typeId.publicId : "")
    let params = ""
    if(this.dataCenterContent?.params) {
      const dataParams = parseQueryString(this.dataCenterContent.params)
      let express = dataParams.express
      const arr = []
      if(express && Array.isArray(express)) {
        this.context.options && (this.context.options.express = express)
        express.forEach(item => {
          if (item.valueType === "CURR_PAGE_FIELD") {
            // 链接参数
            if (item.val === "999999" && item.linkVal && getQueryParam(item.linkVal)) {
              arr.push({
                id: item.linkVal,
                val: getQueryParam(item.linkVal)
              })
            }
            if (item.val && item.val !== "999999") {
              let detailData = localStorage.getItem("detailData")
              detailData = detailData ? JSON.parse(detailData)[0] : {}
              for (let key in detailData) {
                if (detailData[key] && detailData[key].srcFlag === item.val && detailData[key].value) {
                  arr.push({
                    id: item.val,
                    val: detailData[key].value
                  })
                }
              }
            }
          }
        })
        if (arr.length > 0) {
          params = JSON.stringify(arr)
        }
      }
    }
    if (params) {
      url += `&params=${encodeURIComponent(params)}`
    }
    return this.context.asyncTask.add(
      this.context.instance.get(`${url + getSwData(this.rectAttr)}&p2=${pageSize}`)
    )
  }
  //开始进行组件生成
  updateSwiperContent({ completeData, drawLayoutAlready, createCb, updateCb, delSlideCb }) {
    // 当数据条数小于最大轮播数时，需要返回数据条数，不重复渲染，数据条数小于每页轮播数时，取每页轮播数
    const {slidesPerView, content, openHideEmptyCell} = this.rectAttr
    // openHideEmptyCell隐藏空白数据开启时取最小长度，不重复渲染
    const slidesLength = openHideEmptyCell ? completeData?.length : slidesPerView
    let maxLength = this.rectAttr.hasOwnProperty("swiperContent") ? this.rectAttr.swiperContent : content?.length
    const slideNumber = completeData?.length < maxLength ? completeData?.length < slidesPerView ? slidesLength : completeData?.length : maxLength
    console.log('slideNumber :>>',slideNumber, maxLength);
    if (completeData?.length && slideNumber < maxLength + 1) {
      let data = {
        ...this.ids,
        mode: "updateMul",
        number: slideNumber
      }
      this.context.$store.dispatch(this.context.request_prefix + "/swiperContentControl", data)
    }
    this.createCb = createCb
    this.updateCb = updateCb
    this.delSlideCb = delSlideCb
    const swiperContent = this.rectAttr.content
    if (completeData?.length) {
      this.updateCb(false, "emptyData", false, null, this.ids)
      swiperContent.forEach((item, index) => {
        const rectIds = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          pageId: this.ids.pageId
        }
        const swiperContent_id = item.swiperContent_id
        let param = Object.assign({ swiperContent_id }, rectIds)
        let completeDataIndex = completeData[index]
        if (!completeDataIndex) {// 当数据小于轮播页时 其他轮播页渲染最后一条数据的值
          completeDataIndex = completeData[completeData.length - 1]
        }
        if (completeDataIndex) {
          this.context.$store.dispatch(this.context.request_prefix + "/changeSwiperContentOptions", {
            ...this.ids,
            option_name: item.swiperContent_id + ".options.dataUrl",
            option_val: completeDataIndex ? completeDataIndex.url : ""
          })
          this.context.$store.dispatch(this.context.request_prefix + "/changeSwiperContentOptions", {
            ...this.ids,
            option_name: item.swiperContent_id + ".options.dataId",
            option_val: completeDataIndex
              ? completeDataIndex.publicId
                ? completeDataIndex.publicId
                : completeDataIndex.id
              : ""
          })
          const result = this.getSwiperContentStatus(completeData[0], [item], true)
          const hasDataK = item.elementOptions.some(
            ele => ele.filedMapping && ele.filedMapping.hasOwnProperty("value") && ele.filedMapping.value !== null
          )
          if (hasDataK) {
            //如果当前轮播页中有字段映射关系就走新逻辑，当前轮播页中的全部组件都没字段映射关系就走老逻辑
            item.elementOptions.forEach(ele => {
              const dataK = ele?.filedMapping?.value
              const isDate = ele?.filedMapping?.isDate
              const dateStyle = ele?.filedMapping?.dateStyle
              const dateTitle = ele?.filedMapping?.dateTitle
              const dataType = ele?.filedMapping?.dataType
              const flag = ele?.filedMapping?.flag
              if (flag && dataK !== null && (!isNaN(dataK) || this.rectAttr.multiImageDetail) && completeDataIndex && completeDataIndex.hasOwnProperty(dataK)) {
                //如果有dataKey 说明有字段映射关系 就优先去那对应映射关系的数据
                param.elementInLayoutId = ele.elementInSwiperId
                let tempDataValue = completeDataIndex[dataK].value
                // 如果有dataType 判断获取格式
                if (dataType === "dataKey") {
                  tempDataValue = completeDataIndex[dataK].key + "：" + completeDataIndex[dataK].value
                } else if (dataType === "dataName") {
                  tempDataValue = completeDataIndex[dataK].key
                }
                // 如果是视频 增加支持云盘判断
                param.option_val = ele.videoObjectId
                ? completeDataIndex[dataK].objectId
                : isDate
                ? formatterDateHandle(completeDataIndex[dataK].value, dateStyle, dateTitle, completeDataIndex[dataK].key)
                : tempDataValue
                let val = param.option_val
                let content_name = this.handleShapeValueName([ele.innerElement])
                const ids = {
                  container_id: this.ids.container_id,
                  rect_id: this.ids.rect_id,
                  pageId: this.ids.pageId,
                  swiperContent_id: param.swiperContent_id,
                  elementInSwiperId: ele.elementInSwiperId,
                  elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
                  path: this.ids.path
                }
                if (ele.innerElement === "cxVideo") {// 处理视频 如果返回的value是图片格式就渲染成图片 附件取url
                  const others = completeDataIndex[dataK]?.others ? JSON.parse(completeDataIndex[dataK].others) : ""
                  // 和后端定的规则 others.mediaType 视频是video 图片是image
                  const valueIsImage = others && others.mediaType === "image"
                  if (completeDataIndex[dataK].value && (isImage(completeDataIndex[dataK].value) || valueIsImage)) {
                    content_name = "videoImageUrl"
                    val = valueIsImage ? completeDataIndex[dataK].value : completeDataIndex[dataK].url
                  } else if (ele.videoImageUrl) {// 如果有图片需要清空
                    this.updateCb("", "videoImageUrl", false, null, ids)
                  }
                }
                this.updateCb(val, content_name, false, null, ids)
              }
              if (
                dataK !== null &&
                (!isNaN(dataK) || this.rectAttr.multiImageDetail) &&
                completeDataIndex &&
                !completeDataIndex.hasOwnProperty(dataK)
              ) {
                const ids = {
                  container_id: this.ids.container_id,
                  rect_id: this.ids.rect_id,
                  pageId: this.ids.pageId,
                  swiperContent_id: param.swiperContent_id,
                  elementInSwiperId: ele.elementInSwiperId,
                  elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
                  path: this.ids.path
                }
                this.updateCb("", "imgSrc", false, null, ids)
                this.updateCb("", "content", false, null, ids)
              }
            })
          } else {
            //如果返回值有swiperContent_id则说明content和后台数据完全一致
            if (
              result !== null &&
              result.length &&
              String(result.swiperContent_id) &&
              String(result.swiperContent_id) !== "undefined"
            ) {
              this.updateSwiperContentElement(completeDataIndex, item)
            } else {
              //否则就进行更新流程
              this.mixUpdateSwiperContentElement(completeDataIndex, item, drawLayoutAlready)
            }
          }
        } else {
          //如果没有数据了 就不执行更新和后续的生成逻辑，把剩余的轮播内的组件清空
          param.mode = "del"
          // 数据改变不影响总轮播条数 一帆提的
          // this.delSlideCb(param)
        }
      })
    } else {
      this.updateCb(true, "emptyData", false, null, this.ids)
      console.log("接口数据为空")
    }
  }
  // 此方法只用来做轮播组件中的单页内的组件的更新流程,不做新增流程
  updateSwiperContentElement(completeData, swiperItemContent) {
    const data = JSON.parse(JSON.stringify(completeData))
    swiperItemContent.elementOptions.forEach(item => {
      const key = Object.keys(data).find(
        it => (!isNaN(it) || this.rectAttr.multiImageDetail) && data[it].component_shape.find(it => it === item.innerElement)
      )
      if (key !== undefined) {
        const val = data[key].value
        const content_name = this.handleShapeValueName(data[key].component_shape)
        const ids = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          pageId: this.ids.pageId,
          swiperContent_id: swiperItemContent.swiperContent_id,
          elementInSwiperId: item.elementInSwiperId,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        }
        this.updateCb(val, content_name, false, null, ids)
        if (item.hasOwnProperty("linkUrl") && data[key]?.url?.length) {
          this.updateCb(data[key].url, "linkUrl", false, null, ids)
        }
        delete data[key]
      } else {
        const ids = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          pageId: this.ids.pageId,
          swiperContent_id: swiperItemContent.swiperContent_id,
          elementInSwiperId: item.elementInSwiperId,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        }
        this.updateCb("", "imgSrc", false, null, ids)
        this.updateCb("", "content", false, null, ids)
      }
    })
  }
  mixUpdateSwiperContentElement(completeData, swiperItemContent, drawLayoutAlready) {
    if (completeData) {
      // 单页内有组件 但是组件不齐全的情况 就单纯更新
      if (swiperItemContent.elementOptions.length >= 1) {
        this.updateSwiperContentElement(completeData, swiperItemContent)
      } else {
        // 做纯新增组件流程
        this.createELementInContent.call(this, completeData, swiperItemContent, drawLayoutAlready)
      }
    }
  }
  createELementInContent(completeData, swiperItemContent, drawLayoutAlready) {
    const mockElement = JSON.parse(JSON.stringify(drawLayoutAlready.elementOptions))
    const data = JSON.parse(JSON.stringify(completeData))
    let totalWidth = 0
    Object.keys(data).some((k, index) => {
      if (mockElement.length === 0 || mockElement.length === index) return true
      //获取当前数据对象
      const dataVal = data[k]
      // 获取menu中与当前数据对象对应的组件类型值一致的组件attribute
      let attribute
      if (mockElement.length) {
        let attrIndexInMockElement = mockElement.findIndex(
          it => (!isNaN(k) || this.rectAttr.multiImageDetail) && dataVal.component_shape.find(_it => _it === it.innerElement)
        )
        if (attrIndexInMockElement !== -1) {
          attribute = JSON.parse(JSON.stringify(mockElement[attrIndexInMockElement]))
          mockElement.splice(attrIndexInMockElement, 1)
        } else {
          return false
        }
      } else {
        attribute = this.getComponentFromMenu(dataVal.component_shape).children[0].attribute.option
        ;[attribute.left, attribute.top] = [totalWidth, 0]
        totalWidth += attribute.width
      }
      // 组件位置修复
      attribute.isActive = false
      // 组件赋值
      attribute[this.handleShapeValueName([attribute.innerElement])] = dataVal.value
      if (attribute.hasOwnProperty("linkUrl") && dataVal?.url?.length) {
        attribute.linkUrl = dataVal.url
      }
      let param = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        pageId: this.ids.pageId,
        swiperContent_id: swiperItemContent.swiperContent_id,
        elementOptions: attribute
      }
      this.createCb(param)
    })
  }
  getComponentFromMenu(shape) {
    const menus = this.context.$store.state.menu.menu.children[1].children
    return menus.find(item => shape.find(it => it === item.shape))
  }
  handleShapeValueName(shapeName) {
    if (shapeName.find(it => it === "imageComponent")) return "imgSrc"
    else if (shapeName.find(it => it === "cxVideo")) return "videoUrl"
    else if (shapeName.find(it => it === "cxAudio")) return "audioUrl"
    else if (shapeName.find(it => it === "cxCode")) return "linkUrlVal"
    else return "content"
  }
}
